(function ($) {
  Drupal.behaviors.contentFilterSetV2 = {
    attached: false,
    nodes: {},
    selectors: {
      html: 'html',
      body: 'body',
      modules: '.js-content-filter-set-v2',
      triggerBtn: '.js-content-filter-cta',
      closeBtn: '.js-content-filter-cta--close, .js-content-filter-header',
      submitBtn: '.js-content-filter-set-submit',
      filterSets: '.js-content-filter-set-filters',
      secondaryFilterSets: '.js-content-filter-set-filters:not(.js-content-filter-set-filters-primary)',
      secondaryFilterBtn: '.js-content-filter-set-button',
      filterSetSection: '.js-content-filter-set-section',
      filterSetTitle: '.js-content-filter-set-title',
      filterSetTitleCount: '.js-content-filter-set-title-count',
      filtersContainer: '.js-content-filter-set-container',
      filtersContainerResetBtn: '.js-content-filter-set-reset',
      controlsContainer: '.js-content-filter-set-formatter-controls',
      filterActiveCount: '.js-content-filter--active-filters-count',
      filterHeaderCountContainer: '.js-content-filter-set-header-results-count',
      filterHeaderCountNumber: '.js-content-count-number',
      filterHeaderCountSingularSuffix: '.js-content-count-singular-suffix',
      filterHeaderCountPluralSuffix: '.js-content-count-plural-suffix',
      primaryFilterSets: '.js-content-filter-set-filters-primary',
      contentFilterFormatter: '.js-content-filter-set-formatter',
      primaryFilterList: '.js-content-filter-set-primary-option',
      primaryFilterListButtons: '.js-content-filter-set-filter-button',
      filterActiveOptionsContainer: '.js-content-filter-active-options-container',
      filterActiveOptionsList: '.js-content-filter-active-options',
      filterActiveOptionsSeparatorPrev: '.js-content-filter-active-options-separator-prev',
      filterActiveOptionsSeparatorNext: '.js-content-filter-active-options-separator-next',
      filterActiveOptionElement: '.js-content-filter-active-option',
      filterActiveOptionElementName: '.js-content-filter-active-option-name',
      filterActiveOptionElementRemove: '.js-content-filter-active-option-remove',
      filterActiveOptionResetBtn: '.js-content-filter-set-reset',
    },
    attach: function (context) {
      var self = this;
      var $modules = $(self.selectors.modules, context);

      if (self.attached) {
        return;
      }
      self.attached = true;

      $modules.each(function () {
        var $module = $(this);
        self.setup($module);
      });
    },
    setup: function ($module) {
      var self = this;
      
      self.getDom($module);
      self.setEvents($module);
    },
    getDom: function ($module) {
      var self = this;

      $module.nodes = {};
      $module.nodes.$html = $(self.selectors.html);
      $module.nodes.$body = $(self.selectors.body);
      $module.nodes.$triggerBtn = $(self.selectors.triggerBtn, $module);
      $module.nodes.$closeBtn = $(self.selectors.closeBtn, $module);
      $module.nodes.$submitBtn = $(self.selectors.submitBtn, $module);
      $module.nodes.$secondaryFilterSets = $(self.selectors.secondaryFilterSets, $module);
      $module.nodes.$secondaryFilterBtn = $(self.selectors.secondaryFilterBtn, $module);
      $module.nodes.$filterSetSection = $(self.selectors.filterSetSection, $module);
      $module.nodes.$filterSetTitle = $(self.selectors.filterSetTitle, $module);
      $module.nodes.$filterSetTitleCount = $(self.selectors.filterSetTitleCount, $module.nodes.$filterSetTitle);
      $module.nodes.$filtersContainer = $(self.selectors.filtersContainer, $module);
      $module.nodes.$filtersContainerResetBtn = $(self.selectors.filtersContainerResetBtn, $module.nodes.$filtersContainer);
      $module.nodes.$controlsContainer = $module.closest(self.selectors.controlsContainer);
      $module.nodes.$filterActiveCount = $(self.selectors.filterActiveCount, $module);
      $module.nodes.$filterHeaderCountContainer = $(self.selectors.filterHeaderCountContainer, $module);
      $module.nodes.$filterHeaderCountNumber = $(self.selectors.filterHeaderCountNumber, $module.nodes.$filterHeaderCountContainer);
      $module.nodes.$filterHeaderCountSingularSuffix = $(self.selectors.filterHeaderCountSingularSuffix, $module.nodes.$filterHeaderCountContainer);
      $module.nodes.$filterHeaderCountPluralSuffix = $(self.selectors.filterHeaderCountPluralSuffix, $module.nodes.$filterHeaderCountContainer);
      $module.nodes.$primaryFilterSets = $(self.selectors.primaryFilterSets, $module);
      $module.nodes.$contentFilterFormatter = $module.closest(self.selectors.contentFilterFormatter);
      $module.nodes.$primaryFilterList = $(self.selectors.primaryFilterList, $module.nodes.$contentFilterFormatter);
      $module.nodes.$primaryFilterListClone = $module.nodes.$primaryFilterList.clone(true);
      $module.nodes.$primaryFilterListCloneButtons = $(self.selectors.primaryFilterListButtons, $module.nodes.$primaryFilterListClone);
      $module.nodes.$filterActiveOptionsContainer = $(self.selectors.filterActiveOptionsContainer, $module);
      $module.nodes.$filterActiveOptionsList = $(self.selectors.filterActiveOptionsList, $module);
      $module.nodes.$filterActiveOptionsSeparatorPrev = $(self.selectors.filterActiveOptionsSeparatorPrev, $module);
      $module.nodes.$filterActiveOptionsSeparatorNext = $(self.selectors.filterActiveOptionsSeparatorNext, $module);
      $module.nodes.$filterActiveOptionElement = $(self.selectors.filterActiveOptionElement, $module);
      $module.nodes.$filterActiveOptionResetBtn = $(self.selectors.filterActiveOptionResetBtn, $module.nodes.$filterActiveOptionsContainer);
    },
    setEvents: function ($module) {
      var self = this;
      var filterPillsScrollActive = false;
      var filterPillsScrollStartX = 0;
      var filterPillsScrollLeft = 0;

      $(document).on('contentFilter.filtered', function (event, $results, $clear = false) {
        self.updateAvailableFilters($module, $results);
        if ($clear) {
          self.clearSelectedFilters($module);
        }
      });

      $(document).on('contentFilter.secondaryFilterReset', function () {
        self.reset($module);
      });

      $(document).on('contentFilter.initSecondaryFilters', function (event, data, formatterAttached) {
        if (!formatterAttached) {
          $module.nodes.$primaryFilterListClone = $module.nodes.$primaryFilterList.clone(true);
          $module.nodes.$primaryFilterListCloneButtons = $(self.selectors.primaryFilterListButtons, $module.nodes.$primaryFilterListClone);
          $module.nodes.$primaryFilterSets.append($module.nodes.$primaryFilterListClone);
        }
        self.renderFilters($module, data);
      });

      $(document).on('contentFilter.passSecondaryFiltersIntoUrl', function () {
        return self.processSecondaryFilters($module);
      });

      $(document).on('keyup', function (event) {
        if (event.key === 'Escape' && $module.nodes.$filtersContainer.is(':visible')) {
          self.close($module);
        }
      });

      $module.nodes.$filtersContainerResetBtn.once().on('click keydown', function (event) {
        if (!self.clickOrEnter(event)) {
          return;
        }
        event.preventDefault();
        self.clearSelectedFilters($module);
      });

      $module.nodes.$filterActiveOptionResetBtn.once().on('click keydown', function (event) {
        var $selectedPrimaryFilterButton = $module.nodes.$primaryFilterListClone.find('.active');
        var selectedPrimaryFilter = $selectedPrimaryFilterButton.length > 0 ? $selectedPrimaryFilterButton.attr('aria-label') : '';

        if (!self.clickOrEnter(event)) {
          return;
        }
        event.preventDefault();
        self.reset($module);
        $(document).trigger('contentFilter.secondaryFilter', [self.getFilterClasses($module), selectedPrimaryFilter]);
        $module.nodes.$triggerBtn.focus();
      });

      // Apply results
      $module.nodes.$submitBtn.once().on('click keydown', function (event) {
        var $button = $(this);
        var $selectedPrimaryFilterButton = $module.nodes.$primaryFilterListClone.find('.active');
        var selectedPrimaryFilter = $selectedPrimaryFilterButton.length > 0 ? $selectedPrimaryFilterButton.attr('aria-label') : '';

        if (event.key === "Tab" && !event.shiftKey) {
          event.preventDefault();
          $module.nodes.$closeBtn.focus();
          return;
        }
        if (!self.clickOrEnter(event)) {
          return;
        }
        event.preventDefault();
        if ($button.hasClass('button--disabled')) {
          return;
        }
        $(document).trigger('contentFilter.secondaryFilter', [self.getFilterClasses($module), selectedPrimaryFilter]);
        self.close($module);
      });

      // Toggle menu
      $module.nodes.$triggerBtn.once().on('click keydown', function (event) {
        if (!self.clickOrEnter(event)) {
          return;
        }
        self.toggleFiltersContainer($module, true);
        $module.nodes.$closeBtn.focus();
      });

      $module.nodes.$closeBtn.once().on('click keydown', function (event) {
        if (event.key === "Tab" && event.shiftKey) {
          event.preventDefault();
          $module.nodes.$submitBtn.focus();
          return;
        }
        if (!self.clickOrEnter(event)) {
          return;
        }
        self.close($module);
      });

      $module.nodes.$filterSetTitle.once().on('click keydown', function (event) {
        var $this = $(this);

        if (!self.clickOrEnter(event)) {
          return;
        }
        if ($this.hasClass('disabled')) {
          return;
        }
        $this
          .toggleClass('opened')
          .next(self.selectors.filterSets)
          .toggleClass('collapsed');
      });

      $module.nodes.$filterActiveOptionsList.once().on('mousedown', function (event) {
        var $filterActiveOptionsList = $(this);
        filterPillsScrollActive = true;
        filterPillsScrollStartX = event.pageX - $filterActiveOptionsList[0].offsetLeft;
        filterPillsScrollLeft = $filterActiveOptionsList[0].scrollLeft;
      }).on('mouseleave mouseup', function () {
        filterPillsScrollActive = false;
      }).on('mousemove', function (event) {
        var $filterActiveOptionsList = $(this);
        var offsetLeft = event.pageX - $filterActiveOptionsList[0].offsetLeft;
        if (!filterPillsScrollActive) return;
        event.preventDefault();
        $filterActiveOptionsList[0].scrollLeft = filterPillsScrollLeft - offsetLeft + filterPillsScrollStartX;
        self.toggleFilterPillsSeparators($module);
      }).on('touchmove scroll', function () {
        self.toggleFilterPillsSeparators($module);
      });
    },
    // Function to fetch query parameters into an object.
    getUrlVars: function () {
      var queryParamObj = {},
        hash = {};
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        queryParamObj[hash[0]] = hash[1];
      }

      return queryParamObj;
    },
    processSecondaryFilters: function ($module) {
      var self = this;
      var activeValues = '';
      var generatedURL = '';

      $module.nodes.$secondaryFilterSets.each(function () {
        var $secondaryFilterItem = $(this);
        var filterKey = $secondaryFilterItem.prev().data('filter-title');
        var $selectedItems = $secondaryFilterItem.find(
          self.selectors.secondaryFilterBtn,
          $module.nodes.$filtersContainer
        );
        var queryVal = [];
        var queryValues = '';

        $selectedItems.each(function () {
          var $selectedItem = $(this);

          if ($selectedItem.hasClass('active')) {
            activeValues = self.sanitizedSecondaryFilter($selectedItem.text().trim());
            queryVal.push(activeValues);
            queryValues = queryVal.join(',');
            filterKey = self.sanitizedSecondaryFilter(filterKey).toLowerCase();
          }
        });
        generatedURL = queryValues
          ? (generatedURL += '&' + filterKey + '=' + queryValues)
          : generatedURL;
      });

      return generatedURL;
    },
    sanitizedSecondaryFilter: function (str) {
      return str.replace(/ /g, '_').trim();
    },
    renderFilters: function ($module, data) {
      var self = this;
      var index = 0;
      var queryParams = self.getUrlVars();

      $module.nodes.$secondaryFilterSets.each(function () {
        var $set = $(this);
        var filterSetData = data[index];
        var secondaryFilters = $set.data('filter-secondary');
        var allSecondaryFilters = [];
        var filterSetWrap = {};

        if (secondaryFilters) {
          if (!allSecondaryFilters[index]) {
            allSecondaryFilters[index] = [];
          }
          secondaryFilters.split(',').forEach(function (filterSecondary) {
            var trimmedFilter = filterSecondary.trim();
            var selector =
              'js-secondary-filter-' +
              index +
              '--' +
              self.sanitizedSecondaryFilter(filterSecondary).toLowerCase();

            if (trimmedFilter.length) {
              allSecondaryFilters[index][trimmedFilter] = selector;
            }
          });
          filterSetData = allSecondaryFilters[index];
        }

        if (filterSetData) {
          filterSetWrap = Object.keys(filterSetData);
          if (!secondaryFilters) {
            filterSetWrap.sort();
          }
          filterSetWrap.forEach(function (key) {
            var $setkey = $set.find('[data-filter =".' + filterSetData[key] + '"]');

            if ($setkey.length === 0) {
              $set = $set.append(
                `<li class="content-filter-set__button js-content-filter-set-button"
                  data-filter=".${filterSetData[key]}" role="checkbox" aria-checked="false" aria-label="${key}" tabindex="0">
                  ${key}
                  </li>`
              );
            }
            Object.keys(queryParams)
              .sort()
              .forEach(function (queryKey) {
                var decodedQueryKey = decodeURIComponent(queryKey);

                if (decodedQueryKey !== 'section' && decodedQueryKey !== 'sort') {
                  var paramVal = queryParams[queryKey];
                  var paramValArr = paramVal.replace(/_/g, ' ').split(',');

                  for (var i = 0; i < paramValArr.length; i++) {
                    if (
                      decodedQueryKey.replace(/_/g, ' ') ===
                        $set.prev().data('filter-title').toLowerCase() &&
                      decodeURIComponent(paramValArr[i]) === key
                    ) {
                      $setkey = $set.find('[data-filter =".' + filterSetData[key] + '"]');
                      $setkey.addClass('selected active').attr('aria-checked', 'true');
                    }
                  }
                }
              });
          });
        }
        index++;
      });

      $module.nodes.$secondaryFilterBtn = $(self.selectors.secondaryFilterBtn, $module.nodes.$filtersContainer);
      $module.nodes.$secondaryFilterBtn.once().on('click keydown', function (event) {
        var selected = $(this).attr('aria-checked') !== 'false';
        if (!self.clickOrEnter(event)) {
          return;
        }
        if ($(this).hasClass('disabled')) {
          return;
        }
        $(this).toggleClass('selected').attr('aria-checked', !selected);
        self.toggleFilterButtons($module);
      });
      self.filter($module);
    },
    clickOrEnter: function (event) {
      return event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter');
    },
    updateAvailableFilters: function ($module, $results) {
      var self = this;
      if ($results && $results.length) {
        $module.nodes.$secondaryFilterBtn.each(function () {
          var selector = $(this).data('filter');

          self.toggleFilterElement($results.filter(selector).length, $(this));
        });
      } else {
        $module.nodes.$secondaryFilterBtn.removeClass('selected').attr('aria-checked', 'false').addClass('disabled').attr('aria-disabled', 'true');
      }
      self.toggleFilterButtons($module);
    },
    toggleFilterElement: function (count, $el) {
      if (count === 0) {
        $el.addClass('disabled').attr('aria-disabled', 'true').removeClass('selected').attr('aria-checked', 'false');
      } else {
        $el.removeClass('disabled').attr('aria-disabled', 'false');
      }
    },
    getFilterClasses: function ($module) {
      var filterClasses = [];

      $module.nodes.$secondaryFilterBtn.filter('.active:not(.selected)').removeClass('active');
      $module.nodes.$secondaryFilterBtn.filter('.selected').addClass('active');
      $module.nodes.$secondaryFilterBtn.filter('.active').each(function () {
        filterClasses.push($(this).data('filter'));
      });

      return filterClasses.join(',');
    },
    getSelectedFilterClasses: function ($module) {
      var selectedFilterClasses = [];

      $module.nodes.$secondaryFilterBtn.filter('.selected').each(function () {
        selectedFilterClasses.push($(this).data('filter'));
      });

      return selectedFilterClasses.join(',');
    },
    // Grabs the filter selectors and joins them
    filter: function ($module) {
      var self = this;
      $(document).trigger('contentFilter.secondaryFilter', [self.getFilterClasses($module)]);
    },
    toggleFilterButtons: function ($module) {
      var self = this;
      var primaryFilterActive = $module.nodes.$primaryFilterListCloneButtons.filter('.active').length;
      var secondaryFilterActive = $module.nodes.$secondaryFilterBtn.filter('.selected').length;
      var totalFilterActive = primaryFilterActive + secondaryFilterActive;

      if (secondaryFilterActive > 0) {
        $module.nodes.$filtersContainerResetBtn.removeClass('disabled').attr('aria-disabled', 'false');
      } else {
        $module.nodes.$filtersContainerResetBtn.addClass('disabled').attr('aria-disabled', 'true');
      }
      if (totalFilterActive > 0) {
        $module.nodes.$filterActiveCount.html('(' + totalFilterActive + ')');
      } else {
        $module.nodes.$filterActiveCount.html('');
      }
      self.updateOverlayResults($module);
      self.updateFilterActiveOptions($module);
      self.updateFilterSetsCount($module);
    },
    clearSelectedFilters: function ($module) {
      var self = this;
      $module.nodes.$secondaryFilterBtn.removeClass('selected').attr('aria-checked', 'false');
      self.toggleFilterButtons($module);
    },
    // Reset filters
    reset: function ($module) {
      var self = this;
      $module.nodes.$secondaryFilterBtn.removeClass('active selected').attr('aria-checked', 'false');
      self.toggleFilterButtons($module);
    },
    // Close menu
    close: function ($module) {
      var self = this;
      self.toggleFiltersContainer($module, false);
      self.clearSelectedFilters($module);
      $module.nodes.$triggerBtn.focus();
    },
    toggleFiltersContainer: function ($module, open) {
      var self = this;
      $module.nodes.$filtersContainer.toggleClass('active', open);
      $module.nodes.$html.toggleClass('content-filter-set-formatter__overlay', open);
      $module.nodes.$body.toggleClass('sticky-header-opened', open);
      if (open) {
        setTimeout(function () {
          $(document).on('click.outsideContentFilters', function (event) {
            var $target = $(event.target);
            if (!$target.closest($module.nodes.$filtersContainer).length > 0) {
              self.close($module);
            }
          });
        }, 1);
        $module.nodes.$secondaryFilterBtn.filter('.active').addClass('selected').attr('aria-checked', 'true');
        $module.nodes.$controlsContainer[0].scrollIntoView();
        $module.trigger('contentFilter.secondaryFiltersOverlay');
      } else {
        $(document).off('click.outsideContentFilters');
      }
      self.activatePrimaryFilterUI($module);
      self.updateOverlayResults($module);
    },
    activatePrimaryFilterUI: function ($module) {
      var $selectedPrimaryFilterButton = $module.nodes.$primaryFilterList.find('.active');
      
      $module.nodes.$primaryFilterSets.find('.active').removeClass('active').attr('aria-checked', 'false');
      $module.nodes.$primaryFilterSets.find('[aria-label="' + $selectedPrimaryFilterButton.attr('aria-label') + '"]').addClass('active').attr('aria-checked', 'true');
    },
    updateOverlayResults: function ($module) {
      var self = this;
      var $selectedPrimaryFilterButton = $module.nodes.$primaryFilterListClone.find('.active');
      var selectedPrimaryFilter = $selectedPrimaryFilterButton.length > 0 ? $selectedPrimaryFilterButton.attr('aria-label') : '';
      var $results = $module.triggerHandler('contentFilter.getOverlayResultsCount', [selectedPrimaryFilter, self.getSelectedFilterClasses($module)]);

      if ($results) {
        $module.nodes.$filterHeaderCountNumber.text($results.length);
        $module.nodes.$secondaryFilterBtn.each(function () {
          var selector = $(this).data('filter');

          self.toggleFilterElement($results.filter(selector).length, $(this));
        });
      
        if ($results.length === 1) {
          $module.nodes.$filterHeaderCountSingularSuffix.removeClass('hidden');
          $module.nodes.$filterHeaderCountPluralSuffix.addClass('hidden');
        } else {
          $module.nodes.$filterHeaderCountSingularSuffix.addClass('hidden');
          $module.nodes.$filterHeaderCountPluralSuffix.removeClass('hidden');
        }
      }
    },
    updateFilterActiveOptions: function ($module) {
      var self = this;
      var $activeSecondaryFilterBtn = $module.nodes.$secondaryFilterBtn.filter('.active');
      var $filterActiveOption = $();
      var $filterActiveOptionRemove = $();
      var $filterActiveOptionName = $();

      if ($activeSecondaryFilterBtn.length > 0) {
        $module.nodes.$filterActiveOptionsContainer.removeClass('hidden');
      } else {
        $module.nodes.$filterActiveOptionsContainer.addClass('hidden');
      }

      $(self.selectors.filterActiveOptionElement).remove();
      $activeSecondaryFilterBtn.each(function () {
        $filterActiveOption = $module.nodes.$filterActiveOptionElement.clone().removeClass('hidden');
        $filterActiveOptionName = $filterActiveOption.find(self.selectors.filterActiveOptionElementName);
        $filterActiveOptionRemove = $filterActiveOption.find(self.selectors.filterActiveOptionElementRemove);
        $filterActiveOption.attr('data-filter', $(this).data('filter'));
        $filterActiveOptionName.text($(this).text().trim());
        $filterActiveOptionRemove.attr('aria-label', $(this).text().trim());
        $filterActiveOptionRemove.once().on('click keydown', function (event) {
          var filter = $(this).closest(self.selectors.filterActiveOptionElement).data('filter');
          var $selectedPrimaryFilterButton = $module.nodes.$primaryFilterListClone.find('.active');
          var selectedPrimaryFilter = $selectedPrimaryFilterButton.length > 0 ? $selectedPrimaryFilterButton.attr('aria-label') : '';

          if (!self.clickOrEnter(event)) {
            return;
          }
          $currentFilter = $module.nodes.$secondaryFilterBtn.filter(
            '[data-filter="' + filter + '"]'
          );
          if ($currentFilter.length > 0) {
            $currentFilter.removeClass('selected active').attr('aria-checked', 'false');
            $module.nodes.$secondaryFilterBtn.filter('.active').addClass('selected').attr('aria-checked', 'true');
            $(document).trigger('contentFilter.secondaryFilter', [self.getFilterClasses($module), selectedPrimaryFilter]);
          }
          $module.nodes.$triggerBtn.focus();
        });
        $filterActiveOption.appendTo($module.nodes.$filterActiveOptionsList);
      });
      self.toggleFilterPillsSeparators($module);
    },
    toggleFilterPillsSeparators: function ($module) {
      var filterActiveOptionsListWidth = Math.ceil($module.nodes.$filterActiveOptionsList[0].getBoundingClientRect().width);
      if ($module.nodes.$filterActiveOptionsList[0].scrollLeft > 0) {
        $module.nodes.$filterActiveOptionsSeparatorPrev.removeClass('hidden');
      } else {
        $module.nodes.$filterActiveOptionsSeparatorPrev.addClass('hidden');
      }
      if (parseInt($module.nodes.$filterActiveOptionsList[0].scrollWidth - $module.nodes.$filterActiveOptionsList[0].scrollLeft) > filterActiveOptionsListWidth) {
        $module.nodes.$filterActiveOptionsSeparatorNext.removeClass('hidden');
      } else {
        $module.nodes.$filterActiveOptionsSeparatorNext.addClass('hidden');
      }
    },
    updateFilterSetsCount: function ($module) {
      var self = this;
      $module.nodes.$filterSetSection.each(function () {
        var $filterSetSection = $(this);
        var $filterSetTitleCount = $(self.selectors.filterSetTitleCount, $filterSetSection);
        var primaryFilterActive = $(self.selectors.primaryFilterListButtons, $filterSetSection).filter('.active').length;
        var secondaryFilterActive = $(self.selectors.secondaryFilterBtn, $filterSetSection).filter('.selected').length;
        var totalFilterActive = primaryFilterActive + secondaryFilterActive;

        if (totalFilterActive > 0) {
          $filterSetTitleCount.html('(' + totalFilterActive + ')');
        } else {
          $filterSetTitleCount.html('');
        }
      });
    },
  };
})(jQuery);
